import React from "react";
import TeamCalendarModal from "./TeamCalendarModal";
import { Team } from "../types/models";

interface TeamCalendarButtonProps {
  team: Team;
}

/**
 * Icon button on the team page that opens the options for adding the team's
 * schedule to a calendar app.
 */
export default function TeamCalendarButton({ team }: TeamCalendarButtonProps) {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      <button
        type="button"
        className="lp-icon-btn"
        onClick={() => setShowModal(true)}
        aria-label="Add schedule to your calendar"
        title="Add schedule to your calendar"
      >
        <i className="bi bi-calendar-plus" aria-hidden="true" />
      </button>
      <TeamCalendarModal
        team={team}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}
